import React from "react";

const RightServiceInstaImgSection2 = (props) => {
  return (
    <div class="">
      <img className="w-32 rounded-2xl p-1  " src={props.image} alt="" />
    </div>
  );
};

export default RightServiceInstaImgSection2;
